var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertInformation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  viewBox: "0 0 26 26"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#84CBEC"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 0C5.8 0 0 5.8 0 13s5.8 13 13 13 13-5.8 13-13S20.2 0 13 0m0 2c6.1 0 11 4.9 11 11s-4.9 11-11 11S2 19.1 2 13 6.9 2 13 2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 10.9v8.6h-2v-8.6z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 7.5,
  r: 1.1
}))));
export default SvgAlertInformation;